import { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import Tooltip from '@atlaskit/tooltip';

import messages from './i18n';

const authorEmailRegex = /<.*>$/;
const authorEmailRegexWithoutBracket = /<([^>]+)>$/;

export const parseCommitAuthor = (rawCommitAuthor: string | undefined) => {
  if (rawCommitAuthor === undefined) {
    return undefined;
  }

  const unknownAuthor = ''; // show blank if raw commit author is not present

  if (!rawCommitAuthor.trim()) {
    return unknownAuthor;
  }
  const name = rawCommitAuthor.replace(authorEmailRegex, '').trim();
  return name.trim() || unknownAuthor;
};

export const parseCommitEmail = (rawCommitAuthor: string | undefined) => {
  if (rawCommitAuthor === undefined) {
    return undefined;
  }

  const match = rawCommitAuthor.match(authorEmailRegexWithoutBracket);
  return match ? match[1] : '';
};

type Props = {
  /** A flag to disable the tooltip indicating the author cannot be matched to a Bitbucket account. */
  disableTooltip?: boolean;
  /** The raw value of the commit's "author" field. */
  rawCommitAuthor: string;
};

class UnmatchedCommitAuthorName extends PureComponent<Props> {
  static defaultProps = {
    disableTooltip: false,
  };

  render() {
    const { disableTooltip, rawCommitAuthor } = this.props;
    const text = parseCommitAuthor(rawCommitAuthor);

    if (!text) {
      return null;
    }

    if (disableTooltip) {
      return text;
    }

    return (
      <Tooltip
        content={
          <FormattedMessage {...messages.unmatchedUnknownCommitAuthorTooltip} />
        }
        position="bottom"
        tag="span"
      >
        <span>{text}</span>
      </Tooltip>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default UnmatchedCommitAuthorName;
